import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export interface ProductType {
	Id: number;
	Name: string;
	Description: string | null;
	Active: boolean;
}

export interface ProductSize {
	Id: number;
	Name: string;
	ProductTypeId: number | null;
	ProductTypeName: string | null;
	SectionCode: string | null;
	Weight: number | null;
	Active: boolean;
	Description: string | null;
}

export const getProductTypes = async (): Promise<ProductType[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: true }];

	const resp = await apiService.callV2("[MILL].[GetProductTypes]", parameters);
	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ProductType[];
	}
	throw new Error(resp.message || "Error fetching product types");
};

export const getProductSizes = async (
	productTypeId?: number | null,
): Promise<ProductSize[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: true }];
	if (productTypeId) {
		parameters.push({ name: "ProductTypeId", value: productTypeId });
	}

	const resp = await apiService.callV2("[MILL].[GetProductSizes]", parameters);
	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ProductSize[];
	}
	throw new Error(resp.message || "Error fetching product sizes");
};
